import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CurrencyDropdownComponent } from '../currency-dropdown/currency-dropdown.component';
import { StoreSwitcherComponent } from '../store-switcher/store-switcher.component';
import { BlockComponent } from '../../block/block.component';
import { TopBarMenuComponent } from '../top-bar-menu/top-bar-menu.component';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
  standalone: true,
  imports: [
    BlockComponent,
    StoreSwitcherComponent,
    CurrencyDropdownComponent,
    TopBarMenuComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopBarComponent {}
